import Card from "./Base/Card";
import React from "react";
import {
  parseCpsPppValue,
  maskParsedAmounts,
  maskRawCpsPppText,
  SCHEME_FULL_NAME,
} from "../utils/parseCpsPppValue";

interface PropsI {
  headText: string;
  /**
   * One string from the API, e.g. CPS\n8,506,054.14\nPPP\n0.00
   */
  mainValue: string;
  hideBalance: boolean;
}

const AccountCard = ({ headText, mainValue, hideBalance }: PropsI) => {
  const parsed = parseCpsPppValue(mainValue);
  const rowsForDisplay =
    hideBalance && parsed.ok
      ? maskParsedAmounts(parsed.rows)
      : parsed.ok
        ? parsed.rows
        : null;
  const fallbackText =
    hideBalance && !parsed.ok ? maskRawCpsPppText(mainValue) : mainValue;

  return (
    <Card className="account-card-component account-card-component--api card">
      <div className="card_text account-card__metric-title">{headText}</div>
      {parsed.ok && rowsForDisplay ? (
        <div
          className="card_head account-card__schemes"
          role="group"
          aria-label={`${headText} by scheme`}
        >
          {rowsForDisplay.map((row) => (
            <div
              key={row.key}
              className={`account-card__scheme account-card__scheme--${row.key.toLowerCase()}`}
            >
              <div className="account-card__scheme-left">
                <span className="account-card__badge" aria-hidden>
                  {row.key}
                </span>
                <span className="account-card__scheme-name">
                  {SCHEME_FULL_NAME[row.key]}
                </span>
              </div>
              <div className="account-card__amount">{row.amount}</div>
            </div>
          ))}
        </div>
      ) : (
        <div
          className="card_head account-card__api-body account-card__api-body--raw"
        >
          {fallbackText}
        </div>
      )}
    </Card>
  );
};

export default AccountCard;
